import Vue from 'vue'
import Dayjs from 'dayjs'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'

Dayjs.extend(quarterOfYear)

Vue.prototype.$dayjs = string => Dayjs(string)
